// Immutable audit scope for patient-facing Trust Journey configuration.
// Ignore reviewer metadata, draft timestamps and internal editorial comments.
const text = (value) => String(value ?? '').trim();
const map = (input, fn) => Object.fromEntries(
  Object.entries(input && typeof input === 'object' && !Array.isArray(input) ? input : {})
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => [key, fn(value)])
);
function clinicalJourneyPayload(journey = {}) {
  return {
    templateId: text(journey.templateId),
    included: journey.included !== false,
    title: text(journey.title),
    serviceName: text(journey.serviceName),
    branding: {
      trustName: text(journey.branding?.trustName),
      logoAlt: text(journey.branding?.logoAlt),
      logoUrl: text(journey.branding?.logoUrl),
    },
    roleOverrides: map(journey.roleOverrides, value => value === false ? false : true),
    stageOverrides: map(journey.stageOverrides, stage => ({
      title: text(stage.title), description: text(stage.description),
    })),
    linkOverrides: map(journey.linkOverrides, link => ({
      title: text(link.title), description: text(link.description),
      url: text(link.url), visible: link.visible !== false,
    })),
  };
}
function clinicalJourneyFingerprint(journey) {
  return JSON.stringify(clinicalJourneyPayload(journey));
}

export { clinicalJourneyPayload, clinicalJourneyFingerprint };
